import { ApiSavedPortfolio } from 'api/rtk-api'

import { PORTFOLIO_TYPE } from '@/constants'

import { Space, Typography } from '../../../components/core-v2'
import { AssetCard } from '../../../components/core-v2/molecules/asset-card'
import { inactiveStatuses, PortfolioStatus } from '../constants'
import { ApprovalStatusTag, StatusTag } from '../layout/approval-status-tag'
import { calculateApprovalTagContent } from '../utils'

export type PortfoliosViewProps = {
  onSelectPortfolio: (portfolioId: string) => void
  portfolios: ApiSavedPortfolio[]
  selectedPortfolio?: ApiSavedPortfolio
}

const PortfoliosView = (props: PortfoliosViewProps) => {
  const { onSelectPortfolio, portfolios, selectedPortfolio } = props

  return (
    <Space mt={3}>
      <ul>
        {portfolios.map(portfolio => {
          const { status: approvalStatus, type } = portfolio
          const isInactive = inactiveStatuses.includes(portfolio.status)
          const typeLabel =
            type === PORTFOLIO_TYPE.FundOfFunds.key ? PORTFOLIO_TYPE.FundOfFunds.value : 'Model'
          const tagContent = calculateApprovalTagContent(approvalStatus)

          return (
            <AssetCard
              key={portfolio.portfolioId}
              assetId={portfolio.portfolioId}
              assetName={portfolio.portfolioName}
              isSelected={
                selectedPortfolio && portfolio.portfolioId === selectedPortfolio.portfolioId
              }
              prependedRow={
                <Space isflex ismax alignItems="center" justifyContent="space-between" mb={2}>
                  <Space isflex alignItems="center">
                    <Space mr={3}>
                      <StatusTag color={isInactive ? 'black' : 'var(--Success)'} size="small">
                        {isInactive
                          ? PortfolioStatus.NEW.toLocaleUpperCase()
                          : PortfolioStatus.ACTIVE.toLocaleUpperCase()}
                      </StatusTag>
                    </Space>
                    <Typography fontSize="13px" fontWeight="normal" variant="b3">
                      {typeLabel}
                    </Typography>
                  </Space>
                  <ApprovalStatusTag tagContent={tagContent} />
                </Space>
              }
              onClickAsset={() => onSelectPortfolio(portfolio.portfolioId)}
            />
          )
        })}
      </ul>
    </Space>
  )
}

export default PortfoliosView
